import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer class="bg-[#f2f4f6] w-full pt-16 pb-8 font-['Inter']">
      <div class="max-w-screen-2xl mx-auto px-8 grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
        <div class="space-y-4">
          <a routerLink="/" class="text-2xl font-bold text-primary">ZAD ERP</a>
          <p class="text-slate-500 text-sm leading-relaxed">Architectural Intelligence for Modern Enterprise. We provide the tools you need to build, manage, and scale your business with precision.</p>
        </div>
        <div class="space-y-4">
          <h4 class="font-bold text-slate-900 uppercase tracking-wider text-xs">Solutions</h4>
          <ul class="space-y-2 text-sm text-slate-500">
            <li><a routerLink="/modules" class="hover:text-primary transition-colors">Modules</a></li>
            <li><a routerLink="/industries" class="hover:text-primary transition-colors">Industries</a></li>
          </ul>
        </div>
        <div class="space-y-4">
          <h4 class="font-bold text-slate-900 uppercase tracking-wider text-xs">Company</h4>
          <ul class="space-y-2 text-sm text-slate-500">
            <li><a routerLink="/pricing" class="hover:text-primary transition-colors">Pricing</a></li>
            <li><a routerLink="/about" class="hover:text-primary transition-colors">About Us</a></li>
          </ul>
        </div>
        <div class="space-y-4">
          <h4 class="font-bold text-slate-900 uppercase tracking-wider text-xs">Contact</h4>
          <div class="text-sm text-slate-500 space-y-1">
            <p><a href="mailto:contact@zad-erp.net" class="hover:text-primary transition-colors">contact&#64;zad-erp.net</a></p>
            <p><a href="tel:+201062017149" class="hover:text-primary transition-colors">+201062017149</a></p>
          </div>
        </div>
      </div>
      <div class="max-w-screen-2xl mx-auto px-8 pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
        <div>&copy; 2026 ZAD ERP. All rights reserved.</div>
        <div class="flex gap-4">
          <a href="#" class="hover:text-slate-900 transition-colors">Privacy Policy</a>
          <span class="text-slate-300">|</span>
          <a href="#" class="hover:text-slate-900 transition-colors">Terms of Service</a>
        </div>
      </div>
    </footer>
  `
})
export class FooterComponent {}
